module.exports = __webpack_public_path__ + "fonts/inter-v3-latin-ext_latin-700.f808d79.woff";